// metodos de actions 

export default {  
  SetActiveDisplay(context,val){
    context.commit('ActiveDisplay', val);  
  },  
    IngresoAccount(context , access){
      context.commit('IngresoAccount', access);
    },
    validToken(){
      return new Promise((resolve, reject) => {
        window.masterApiv2.post('validarToken', 
          {
            user_id: localStorage.getItem('mark_client_data_m'),
            oauth_id: localStorage.getItem('oauth_m'),
          }
        ).then(response => {
          //console.log('bien desde el token de M');
          resolve(response);
          window.emailVerify=response.data.emailVerify;
        })
        .catch(error => {
          console.log(error);
          reject(error)
        });
      });
    },
    destroyToken(context) {
      context.commit('destroyToken')
      console.log('ok', context.getters.loggedIn)
      if (!context.getters.loggedIn) {
        console.log('logout');
         return new Promise((resolve, reject) => {
          window.master.post('logout')
            .then(response => {
              console.log('salir');
              context.commit('destroyToken')
              context.commit('IngresoAccount', false);
              context.commit('exit_Apps');
              resolve(response)
            })
            .catch(error => {
              console.log(error);
              context.commit('destroyToken');
              context.commit('IngresoAccount', false);
              context.commit('exit_Apps');
              reject(error)
            })
        })
      }
    },
    retrieveToken(context, credentials) {
      //debugger;
      return new Promise((resolve, reject) => 
      {
        if(credentials.validM == true)
        {
            //login desde M            
            const token = localStorage.getItem('access_token_m'); // token master
            window.localtoken_M = token;
            context.commit('retrieveToken', token);
            context.commit('IngresoAccount', true);
            window.master.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            window.master_client = localStorage.getItem('master_client_data'); // master_user_id           
            window.localAccountID = localStorage.getItem('mark_client_data_m'); // user_id
            window.localuserdata = localStorage.getItem('mark_client_data'); // org_id
            window.localorgdata = localStorage.getItem('mark_client_data'); // org_id
            window.user_type = localStorage.getItem('user_type'); // user_type 
            console.log('login master');
            resolve(true);
            
        }
        else{
          reject(false);
        }
      });
    },
    loginAuxiliar(context, credentials) {
      //login
      return new Promise((resolve, reject) => {
        window.masterApiv2.post('/loginauxiliar', {
          email: credentials.email,
          password: credentials.password,
        })
        .then(response => {
          // console.log('login auxiliar',response.data);
          if(response.data.status){
            localStorage.setItem("access_token_m", response.data.token);// token master
            localStorage.setItem("master_client_data", response.data.master_user_id);// master_user_id
            localStorage.setItem("mark_client_data_m", response.data.user_id);// user_id
            localStorage.setItem("mark_client_data", response.data.org);// org_id
            localStorage.setItem("user_type", response.data.user_type);// user_type 
            localStorage.setItem("oauth_m", response.data.oauth);//llave de sesion
            localStorage.setItem("start", response.data.d);// fecha de inicio 
            let lang = (response.data.lang == 1) ? "en" : "es";
            localStorage.setItem('langLocal', lang); // idioma por defecto de la org
            context.commit('retrieveToken', localStorage.getItem('access_token_m'));
            context.commit('IngresoAccount', true);
            window.localtoken_M = localStorage.getItem('access_token_m'); // token master
            window.master_client = localStorage.getItem('master_client_data'); // master_user_id           
            window.localAccountID = localStorage.getItem('mark_client_data_m'); // user_id
            window.localuserdata = localStorage.getItem('mark_client_data'); // org_id
            window.localorgdata = localStorage.getItem('mark_client_data'); // org_id
            window.user_type = localStorage.getItem('user_type'); // user_type 
            const token = localStorage.getItem('access_token_m'); // token master
            window.master.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token_m');
            resolve(true);
          }else{
            console.log(response);
            reject(false);
          } 
        })
        .catch(error => reject(false));
      });
    }, 
    privilegies_session(context){
      let user_id = window.localAccountID;
      let org_id = window.localorgdata;      
      if(org_id > 0)
      {
        let privilegies={ alls : false, modulos: [] };
        if(window.user_type==0)
        {
          privilegies.alls=true;
          context.commit('set_privilegies', privilegies);
          // console.log('pasando privilegios', privilegies);
        }
        else
        {
          window.master.get('privilegiessession/'+user_id+'/'+org_id)
          .then(response => {
            privilegies.modulos=response.data.result
            // console.log('pasando privilegios', privilegies);
            context.commit('set_privilegies', privilegies);
          })
          .catch(error => {
            console.log(error);
          });
        }
      }
    },
    apps_modulos(context, app_id){
      window.master.get('appmodulos/'+app_id)
      .then(response => {
        //console.log('modulos de app_id = '+app_id)
        //console.log('modulos = ', response.data.result)
        context.commit('set_app_modulos', response.data.result);
      })
      .catch(error => {
        console.log(error);
      });
    },
    access_Dimenu(context , accessDimenu){
      context.commit('IngresoDimenu', accessDimenu);
    },
    exit_Apps(context)
    {
      context.commit('exit_Apps');
    },
    OrgAccountAll (context) {
      return new Promise((resolve, reject) => {
        let url ='organizationall';
        if(window.user_type==2){url ='orgallsecundary';}
        window.master.get(url+'/' + window.localAccountID)
        .then(response => {
          context.commit('SET_ORG_All', response.data.result);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error)
        });
      });
    },
    ActiveOrg(context , id){
      context.commit('SELECT_ORG_ACTIVE', id)
    },
    ActiveOrgdataByUser(context,org_id){
      if(org_id > 0)
      {
        window.master.get('orginfoactivebyuser/'+ org_id)
        .then(response => {
          //debugger;
          localStorage.setItem('mark_client_data', response.data.result.id); // org_id
          context.commit('SET_ORGINFO', response.data.result )
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    ActiveOrgdata(context,idorg){
      if(idorg > 0)
      {
        window.master.get('orginfoactive/'+ idorg)
        .then(response => {
          context.commit('SET_ORGINFO', response.data.result );
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    ListAppsbyOrg(context,idorg){
      return new Promise((resolve, reject) => {
        if(idorg > 0)
        {
          window.master.get('getapp/'+idorg)
          .then(response => {
            //console.log('ListAppsbyOrg',response.data)
            resolve(response.data.r); 
            context.commit('SET_APPLIST', response.data.r );            
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
        }else{reject(false);}
      });
    },
    ListAppsForOrgOfSecondary(context,idorg){
      return new Promise((resolve, reject) => {
        if(idorg > 0)
        {
          window.master.get('getappsecondary/'+idorg)
          .then(response => {
            //console.log('ListAppsbyOrg',response.data)
            resolve(response.data.r); 
            context.commit('SET_APPLIST', response.data.r );            
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
        }else{reject(false);}
      });
    },

    SET_APP_ID(context,app_id){
      localStorage.setItem('appIDactual', app_id);
      context.commit('SetAppIDactual');
    },
    getCurrency(context){
      return new Promise((resolve, reject) => {
        if(localStorage.getItem('currency')==null){localStorage.setItem('currency','$');}
        window.master.get('menu/information/GetCurrency/'+window.localAccountID+'/'+window.localorgdata)
        .then(response => {
          if(response.data.status)
          {
            localStorage.setItem('currency',response.data.currency);
            resolve(true);
          }else{reject(false);}
        })
        .catch(error => {
          console.log(error);
          reject(false);
        });
        
      });
    },
    getCategories(context,i)
    {
      return new Promise((resolve, reject) => {
        window.master.get('categories/'+window.localuserdata+'/'+i.id )
        .then((response) => {
            resolve(response.data.result);
        }).catch((error) => {
          console.log(error); 
            reject(false);
        });
      });
    },

}
